export default __webpack_public_path__ + "static/media/EQUIPEMENT DE SÉCURITÉ LABORATOIRE.39538692.svg";